import { render, staticRenderFns } from "./CollectionsTable.vue?vue&type=template&id=3244d092&"
import script from "./CollectionsTable.vue?vue&type=script&lang=js&"
export * from "./CollectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsTable.vue?vue&type=style&index=0&id=3244d092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports